/*****
 * 未處理:
 *  scrolllock true 時, 螢幕寬度再度改變的處置
 */

import GS from "@ts/GlobalSetting";
import ViewportRoot from "@ts/sframe/ViewportRoot";

let $root: JQuery,
  $sectionWrapper: JQuery,
  $footer: JQuery;

let $scrollWrapper: JQuery,
  _isScrollLocking: boolean = false;

let _oldScrollTop: number,
  _oldScrollLeft: number;

class Pages {

  static init() {
    $root = $("#page-root")

    $scrollWrapper = $root.find(".scroll-wrapper")

    $sectionWrapper = $root.find(".section-wrapper");
    $footer = $("footer");
  }

  static toggleScrollLock(lockOn: boolean) {
    if (lockOn === _isScrollLocking) return;
    _isScrollLocking = lockOn;

    if (_isScrollLocking) {
      _oldScrollTop = window.scrollY;
      _oldScrollLeft = window.scrollX;

      $root.attr("scoll-locking", "true")
      $scrollWrapper.css("left", -_oldScrollLeft)
      $scrollWrapper.css("top", -_oldScrollTop)
    }
    else {
      $root.attr("scoll-locking", "false")

      window.scrollTo(_oldScrollLeft, _oldScrollTop)
      $scrollWrapper.css("left", "")
      $scrollWrapper.css("top", "")
    }
  }

}

export default Pages;